const config = {
  serverUrl:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:4005'
      : 'https://spotify.hartenfeller.dev'
};

export default config;
